// extracted by mini-css-extract-plugin
module.exports = {"container":"_2W6qJyDKbrLUlc4F_QyWpP","visible":"_1sNtAFaIHxZuixVrjRhwP4","cancelBtn":"-_G-q_j_cbtpahcCvGLo9","icon":"_3EnCsbNxs5gpjDMriABWkM","saveBtn":"_2u2viC2WKyf0GpVCLJNSOE"};